import { render, staticRenderFns } from "./referralform.vue?vue&type=template&id=35e9cdd6&scoped=true&"
import script from "./referralform.vue?vue&type=script&lang=js&"
export * from "./referralform.vue?vue&type=script&lang=js&"
import style0 from "./referralform.vue?vue&type=style&index=0&id=35e9cdd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e9cdd6",
  null
  
)

export default component.exports